export const sidebar = {
  header: {
    menu: "MENU",
  },
  items: {
    home: "Inicio",
    reservations: "Reservas",
    calendar: "Calendario",
    hourlyCalendar: "Por horas",
    calls: "Llamadas",
    aiReception: "Recepción IA",
    availabilityRates: "Disponibilidad y tarifas",
    checkins: "Check-ins",
    channels: "Canales de reserva",
    inbox: "Buzón de entrada",
    settings: "Configuración",
    experiences: "Experiencias",
    scheduleCall: "Programa una llamada",
    support: "Soporte",
    novedades: "Novedades",
    messages: "Mensajes",
    badgeNew: "Nuevo",
    invoicing: "Facturación",
    customers: "Clientes",
    clientsDirectory: "Clientes",
    fiscalCustomers: "Clientes fiscales",
    invoices: "Facturas",
    housekeeping: "Limpieza",
    analytics: "Analytics",
  },
  alt: {
    logo: "Logo",
  },
};
